export default {"src":"/_next/static/media/erp.fbeb9e08.svg","height":50,"width":50};